<template>
  <ul class="timeline timeline-fluid">
    <li class="timeline-item" v-for="activity in activities">
      <div class="timeline-figure">
        <span class="tile tile-circle tile-sm"><i class="far fa-calendar-alt fa-lg"></i></span>
      </div>
      <div class="timeline-body">
        <div class="media">
          <div class="media-body">
            <p class="mb-0" v-html="activity.description">
            </p><span class="timeline-date">{{ formatDate(activity.created_at) }}</span>
          </div>
        </div>
      </div>
    </li>
    
    <li v-if="loading" class="timeline-item text-center d-flex justify-content-center py-2">
      <spinner class="text-primary"></spinner>
    </li>
  </ul>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import Spinner from '../ui/Spinner'
  import moment from 'moment'
  
  export default {
    name: 'ActivityList',
    components: { Spinner },
    props: {
      model: String,
      protocol: Object,
    },
    data () {
      return {
        loading: false,
      }
    },
    methods: {
      ...mapActions({
        getActivities: 'users/getActivities',
      }),
      
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:MM:SS')
      },
    },
    computed: {
      ...mapGetters({
        activities: 'users/activities',
      }),
    },
    async mounted () {
      this.loading = true
      
      await this.getActivities({
        id: this.protocol.id,
        model: this.model,
      })
      
      this.loading = false
    },
  }
</script>
